export default __webpack_public_path__ + "static/media/hash_dice.96f77595.webp";